import { SxProps, Theme } from '@mui/system';

const styles = {
  upgradeCardContainer: {
    border: '1px solid',
    padding: '24px',
    borderColor: 'common.border',
    borderRadius: '8px',
  },
  priceContainer: {
    borderTop: '1px solid',
    borderColor: 'common.border',
    mt: '16px',
    py: '16px',
  },
  infoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  label: {
    fontSize: 16,
    color: 'grey.800',
  },
  value: {
    fontWeight: '700',
    color: 'primary.main',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: '16px',
  },
  buttonText: {
    padding: 0,
    textDecoration: 'underline',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
